import React from "react";
import "../Card.css";

type BasicCardProps = {
    children: string;
    onClick: () => void;
};

export const BasicCard: React.FC<BasicCardProps> = ({ children, onClick }) => {
    return (
        <div className="basic-card" onClick={onClick}>
            {children}
        </div>
    );
};
